module.exports = __webpack_public_path__ + "static/media/Group2.5e6129f9.png";